<template>
    <div class="window bg">
        <div class="container">

            <menu-option v-bind:back="true" v-bind:is-white="true" v-bind:is-help="false"
                         class="container-horizontal_flex-start" v-bind:back-route="'/menu'"></menu-option>
            <div class="img-container">
                <transition :css="false" @enter="enterAnimation" appear>
                    <img v-bind:src="getCharacter.fullImage" class="img-container_img">
                </transition>

                <transition :css="false" @enter="enterAnimation" appear>
                    <character-talk v-bind:text="text" v-bind:route="'/free-start'"
                                    v-bind:show-next="true"  v-bind:show-name="true"></character-talk>
                </transition>

            </div>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import CharacterTalk from '../components/CharacterTalk';
    import Counter from '../components/Counter';
    import MenuOption from '../components/MenuOption';
    import RecordMixin from '../mixins/RecordMixin';
    import anime from 'animejs';


    export default {
        name: "FreeTalk",
        computed: {
            ...mapGetters(['getCharacter'])

        },
        components: {
            MenuOption,
            Counter,
            CharacterTalk,
        },
        methods: {
            enterAnimation(el, done) {
                const ani = anime({
                    targets: el,
                    opacity: [0, 1],
                    easing: 'easeInQuad'
                })
            }
        },
        watch: {},
        data() {
            return {
                text: '<ruby>実践<rt>じっせん</rt></ruby>モードを<ruby>始<rt>はじ</rt></ruby>めます。<br>' +
                    'ここをタップしてわたしに<ruby>色々<rt>いろいろ</rt></ruby>と<ruby>話<rt>はな</rt></ruby>しかけてください。'
            }
        },
        mixins: [RecordMixin],
        mounted() {
        }
    }
</script>

<style scoped>
</style>
